import {
  ChangeDetectorRef, Directive, HostBinding, Input, OnChanges, OnDestroy, OnInit,
  SimpleChanges
} from "@angular/core";
import {FileService} from "../../http/file.service";
import {Subscription} from "rxjs/Subscription";
import {DomSanitizer} from "@angular/platform-browser";
import {HttpClient} from "@angular/common/http";

@Directive({
  selector: '[vbPrivateImage]'
})
export class PrivateImageDirective implements OnInit, OnDestroy, OnChanges {

  private imageData: any;
  @Input('vbPrivateImage') path: string;

  private _src;

  set src(value) {
    this._src = value;
  };

  @HostBinding('src')
  get src() {
    if (this._src) {
      return this._src;
    } else {
      return '';
    }
  }

  @HostBinding('style.visibility')
  get visible(): string {
    if (this.src) {
      return 'visible';
    } else {
      return 'hidden';
    }
  }

  constructor(private fileService: FileService, private sanitizer: DomSanitizer, private cd: ChangeDetectorRef) {
  }

  private sub: Subscription;

  ngOnInit() {
    this.loadFile();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.path) {
      this.loadFile();
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  loadFile() {
    this.src = null;
    this.cd.detectChanges();
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.fileService.getPrivateFile(this.path)
      .subscribe(data => {
        let urlCreator = window.URL;
        this.imageData = urlCreator.createObjectURL(data);
        this.src = this.sanitizer.bypassSecurityTrustUrl(this.imageData);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/directives/private-image.directive.ts